// extracted by css-extract-rspack-plugin
export default {"bannerList":"TaskCreationFailedBanner-module__bannerList__i4NQC"};